import React from 'react';
import { useTranslation } from 'react-i18next';

import './More.scss';

import SectionTitle from '../../components/SectionTitle/SectionTitle';

import { BsFillCheckCircleFill } from 'react-icons/bs';

import expertImg from '../../assets/expert.webp';

const More = () => {
    const { t } = useTranslation();

    return (
        <section
            className="expert-section"
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <div className="container">

                <div className="row align-items-center">

                    <div className="col-lg-6 col-md-6">

                        <div className="expert-text">

                            <SectionTitle
                                title={t('more.title')}
                                description={t('more.description')}
                            />

                            <ul>

                                <li>
                                    <BsFillCheckCircleFill />
                                    {t('more.email')}
                                </li>

                                <li>
                                    <BsFillCheckCircleFill />
                                    {t('more.phone')}
                                </li>

                                <li>
                                    <BsFillCheckCircleFill />
                                    {t('more.personal')}
                                </li>

                            </ul>

                        </div>

                    </div>

                    <div className="col-lg-6 col-md-6">

                        <div className="expert-img">

                            <img
                                src={expertImg}
                                alt={t('more.imageAlt')}
                            />

                        </div>

                    </div>

                </div>

            </div>
        </section>
    );
};

export default More;